import { type ConfluenceCreateDatabaseCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { logError } from '@databases/logs';

import { getConfluenceService } from '@canvas/atlassian-service/confluence';

import { DatabaseStreamState } from '../database-stream-state';

const streamState = DatabaseStreamState.getInstance();

export const createDatabase = async (
  params: ConfluenceCreateDatabaseCommandProperties,
  contentId: string
) => {
  if (params.isStreamComplete) {
    try {
      await getConfluenceService().updateContentTitle(contentId, params.data.title);
    } catch (possibleError) {
      const error =
        possibleError instanceof Error ? possibleError : new Error(String(possibleError));
      logError('Error updating native database title', error);
      throw error;
    } finally {
      await streamState.completeStreaming();
    }
    return;
  }

  if (!streamState.isStreamingActive) {
    streamState.startStreaming(contentId, params.groupId, {
      shouldClearContent: true,
    });
  }

  streamState.processChunk(params.data.document);
};
